import { SagaIterator } from 'redux-saga';
import { put, call } from 'redux-saga/effects';
import Api from '../../../modules/utils/API';
import {
  errorsGlobalError,
  fetchTemplatesFailed,
  fetchTemplatesSuccess,
  fetchTemplatesFontsSuccess
} from '../../../modules/actions';
import ApiErrors from '../../../modules/utils/API/APIErrors';

export const fetchTemplatesSaga = function* (): SagaIterator {
  try {
    const response = yield call(Api.Templates.get);
    ApiErrors.checkOnApiError(response);
    // Guard against non-array payloads (BE/proxy occasionally returns an
    // error-shaped object or HTML); downstream consumers call .find/.map
    // on this and would crash otherwise.
    yield put(fetchTemplatesSuccess(Array.isArray(response) ? response : []));
  } catch (e) {
    yield put(fetchTemplatesFailed());
    yield put(errorsGlobalError(e as ErrorEvent));
  }
};

export const fetchTemplatesFontsSaga = function* (): SagaIterator {
  try {
    const response = yield call(Api.Templates.getTempalteFonts);
    ApiErrors.checkOnApiError(response);
    yield put(fetchTemplatesFontsSuccess(response.result.fonts));
  } catch (e) {
    yield put(errorsGlobalError(e as ErrorEvent));
  }
};
